interface FinalCTASectionProps {
  onGetQuote: () => void;
}

export default function FinalCTASection({ onGetQuote }: FinalCTASectionProps) {
  return (
    <section className="relative w-full py-36 px-6 lg:px-12 flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('https://cdn.sanity.io/images/lncy278u/production/ba45fe56ae5b17debcd8e30878ab108340438a78-4032x3024.webp')" }}
      />
      {/* Overlay */}
      <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, rgba(10,10,10,0.88) 0%, rgba(10,10,10,0.72) 100%)" }} />

      <div className="relative z-10 max-w-3xl mx-auto text-center w-full">
        <span
          className="text-stone-400 text-xs uppercase tracking-[0.28em] font-medium block mb-6"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Get Started
        </span>
        <h2
          className="text-white font-semibold mb-6 leading-tight"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(2.4rem, 5vw, 4.2rem)" }}
        >
          Build It Right
          <br />
          <span className="font-light italic text-stone-300">the First Time</span>
        </h2>
        <p
          className="text-stone-300 text-base leading-relaxed mb-12 max-w-xl mx-auto"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
        >
          Structurally sound, visually clean, and designed to last. Your outdoor space deserves craftsmanship that holds up — season after season.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={onGetQuote}
            className="px-12 py-4 bg-white text-stone-900 font-semibold text-sm uppercase tracking-[0.12em] rounded-sm hover:bg-stone-100 transition-all whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Get a Free Quote
          </button>
          <a
            href="tel:4167241172"
            className="flex items-center gap-2.5 px-12 py-4 border border-white/40 text-white font-medium text-sm uppercase tracking-[0.12em] rounded-sm hover:bg-white/10 hover:border-white transition-all whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <i className="ri-phone-line text-sm"></i>
            (416) 724-1172
          </a>
        </div>
      </div>
    </section>
  );
}
